import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MaintenanceEntry, MaintenanceInput } from '@vuokramani/shared';
import { api } from './api.ts';

/** Asunnon huoltokirja, uusin ensin. Vuokralainen saa vain hänelle näkyvät, ilman hintaa. */
export function useMaintenance(propertyId: string | undefined) {
  return useQuery({
    queryKey: ['maintenance', propertyId],
    queryFn: () =>
      api<{ entries: MaintenanceEntry[] }>(`/properties/${propertyId}/maintenance`).then(
        (r) => r.entries,
      ),
    enabled: Boolean(propertyId),
  });
}

export function useSaveMaintenance(propertyId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id?: string; body: MaintenanceInput }) =>
      id
        ? api<MaintenanceEntry>(`/maintenance/${id}`, { method: 'PUT', body })
        : api<MaintenanceEntry>(`/properties/${propertyId}/maintenance`, { method: 'POST', body }),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['maintenance', propertyId] }),
  });
}

export function useDeleteMaintenance(propertyId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api<void>(`/maintenance/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['maintenance', propertyId] });
      // Liitteet jäävät Tiedostoihin ilman linkkiä.
      void queryClient.invalidateQueries({ queryKey: ['files', propertyId] });
    },
  });
}
